export const IS_DEV = process.env.NODE_ENV === 'development'

export function dicomDateToDate(strDate) {
  if (!strDate) { return new Date(NaN) }
  const tryIso = isoStrToDate(strDate)
  if (!isNaN(tryIso.getTime())) {
    return tryIso
  }
  const ints = strDate.replace(/(\d{4})(\d\d)(\d\d)/, "$1 $2 $3").split(" ");
  return new Date(
    parseInt(ints[0], 10),
    parseInt(ints[1], 10)-1,
    parseInt(ints[2], 10)
  );
}

export const isoStrToDate = (str) => {
  if (!str) {
    return new Date(str);
  }
  const [date,time] = str.split(/[\sT]/)
  const [year,month,day] = date.split("-")
  const [hour,minutes] = time ? time.split(":") : [0,0]
  return new Date(Number(year),Number(month)-1,Number(day),Number(hour),Number(minutes))
}

export const getKeyImageNameOrPlaceholder = (keyImage, index) => keyImage.name || '' || ('Key Image #' + (index + 1))
